<div class="bg-white">
	<nav class="navbar-expand-lg analytics-nav py-2">
		<div class="navbar-collapse">
			<ul class="navbar-nav mr-auto">
				<li class="nav-item" *ngIf="hasBasicSetupPermission" [ngClass]="{'active': isActiveTab('public-ranking-page')}">
					<a class="nav-link py-1 pointer" [routerLink]="['/', customerId, siteId, 'charglink-brm', 'public-ranking-page']" (click)="commonService.handleLinkClickEvents($event)">{{'nav.public_ranking_page' | translate}}</a>
				</li>
				<li class="nav-item" *ngIf="true" [ngClass]="{'active': isActiveTab('detailed-ranking-page')}">
					<a class="nav-link py-1 pointer" [routerLink]="['/', customerId, siteId, 'charglink-brm', 'detailed-ranking-page']" (click)="commonService.handleLinkClickEvents($event)">{{'nav.detailed_ranking_page' | translate}}</a>
				</li>
				<li class="nav-item" *ngIf="true" [ngClass]="{'active': isActiveTab('site-history')}">
					<a class="nav-link py-1 pointer" [routerLink]="['/', customerId, siteId, 'charglink-brm', 'site-history']" (click)="commonService.handleLinkClickEvents($event)">{{'nav.site_history' | translate}}</a>
				</li>
				<li class="nav-item" *ngIf="true" [ngClass]="{'active': isActiveTab('brm-groups')}">
					<a class="nav-link py-1 pointer" [routerLink]="['/', customerId, siteId, 'charglink-brm', 'brm-groups']" (click)="commonService.handleLinkClickEvents($event)">{{'nav.brm_groups' | translate}}</a>
				</li>
				<li class="nav-item" *ngIf="false" [ngClass]="{'active': isActiveTab('brm-potentially-malfunctioned-chargers')}">
					<a class="nav-link py-1 pointer" [routerLink]="['/', customerId, siteId, 'charglink-brm', 'brm-potentially-malfunctioned-chargers']" (click)="commonService.handleLinkClickEvents($event)">{{'admin.brm_potentially_malfunctioned_chargers' | translate}}</a>
				</li>
			</ul>
		</div>
	</nav>
</div>

<div [ngSwitch]="activePage">
	<app-charglink-brm-public *ngSwitchCase="'public-ranking-page'" [siteId]="siteId" [isTabMode]="true"></app-charglink-brm-public>
	<app-charglink-brm-site-history *ngSwitchCase="'site-history'" [customerId]="customerId" [siteId]="siteId"></app-charglink-brm-site-history>
	<app-brm-groups *ngSwitchCase="'brm-groups'" [siteId]="siteId"></app-brm-groups>
	<app-detailed-ranking-page *ngSwitchCase="'detailed-ranking-page'" [siteId]="siteId"></app-detailed-ranking-page>
	<app-brm-potentially-malfunctioned-chargers *ngSwitchCase="'brm-potentially-malfunctioned-chargers'" [customerId]="customerId" [siteId]="siteId"></app-brm-potentially-malfunctioned-chargers>
</div>
